export const waNumberFrom = (contact = {}) =>
  (contact.whatsapp || "").replace(/\D/g, "") || (contact.phone2 || "").replace(/\D/g, "").replace(/^0/, "880");

export const buildWaMessage = (title, rows) =>
  [`*${title}* — Fly Jannah`, ...rows.filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== "").map(([k, v]) => `*${k}:* ${v}`)].join("\n");

export const waLink = (contact, message) => `https://wa.me/${waNumberFrom(contact)}?text=${encodeURIComponent(message)}`;

export const openWhatsApp = (contact, message) => window.open(waLink(contact, message), "_blank", "noopener");
